import { ExternalLink } from "lucide-react"
import { safeOrderUrl } from "./order-detail-model"
import { cn } from "../../lib/utils"

export function OrderExternalLink({
  url,
  label,
  className,
}: {
  url: string | null
  label: string
  className?: string
}) {
  const safeUrl = safeOrderUrl(url)
  const classes = cn(
    "inline-flex min-h-11 items-center justify-center gap-1.5 text-xs font-medium text-info focus-visible:outline-2 focus-visible:outline-ring sm:min-h-8",
    className
  )
  if (!safeUrl) {
    return (
      <span aria-disabled="true" className={cn(classes, "text-muted-foreground")}>
        {label} unavailable
      </span>
    )
  }
  return (
    <a href={safeUrl} target="_blank" rel="noopener noreferrer" className={classes}>
      {label}

      <ExternalLink className="size-3" />
    </a>
  )
}
